import { render, staticRenderFns } from "./social-embedded.vue?vue&type=template&id=4f8a2934&scoped=true"
import script from "./social-embedded.vue?vue&type=script&lang=js"
export * from "./social-embedded.vue?vue&type=script&lang=js"
import style0 from "./social-embedded.vue?vue&type=style&index=0&id=4f8a2934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8a2934",
  null
  
)

export default component.exports